"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _warning = _interopRequireDefault(require("fbjs/lib/warning"));

var _radium = _interopRequireWildcard(require("radium"));

var _GodsEye = require("@meepshop/context/lib/GodsEye");

var _constants = require("./constants");

var _modules = _interopRequireDefault(require("./modules"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("./styles/widget.less");

var styles = {
  "screenSmMax": "767px",
  "root": "meepshop-meep-ui__block-widget__root",
  "wrapper": "meepshop-meep-ui__block-widget__wrapper"
};
/**
 * odd level to vertical layout
 * even level to horizontal layout
 *
 * ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
 * ┃ level 1                     ┃
 * ┃ ┏━━━━━━━━━━━━━┓ ┏━━━━━━━━━┓ ┃
 * ┃ ┃ level 2     ┃ ┃ level 2 ┃ ┃
 * ┃ ┃ ┏━━━━━━━━━┓ ┃ ┗━━━━━━━━━┛ ┃
 * ┃ ┃ ┃ level 3 ┃ ┃             ┃
 * ┃ ┃ ┗━━━━━━━━━┛ ┃             ┃
 * ┃ ┃ ┏━━━━━━━━━┓ ┃             ┃
 * ┃ ┃ ┃ level 3 ┃ ┃             ┃
 * ┃ ┃ ┗━━━━━━━━━┛ ┃             ┃
 * ┃ ┗━━━━━━━━━━━━━┛             ┃
 * ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
 * ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
 * ┃ level 1                     ┃
 * ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
 */

var Widget = function Widget(props) {
  var _props$module = props.module,
      module = _props$module === void 0 ? null : _props$module,
      _props$widgets = props.widgets,
      widgets = _props$widgets === void 0 ? null : _props$widgets,
      _props$hiddenModules = props.hiddenModules,
      hiddenModules = _props$hiddenModules === void 0 ? [] : _props$hiddenModules,
      widgetSetting = props.widgetSetting,
      flattenedWidgets = props.flattenedWidgets,
      globalCarousel = props.globalCarousel,
      id = props.id,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["module", "widgets", "hiddenModules", "widgetSetting", "flattenedWidgets", "globalCarousel", "id"]);
  if (module === 'smart-conversion' && !restProps.displaySample) return null; // 我們可以在 Parent Component 設定想要隱藏的 module

  if (hiddenModules.includes(module)) return null;
  (0, _warning["default"])(widgets || !widgets && module, 'If `widgets` of the `Widget` is `null`, `module` can not be `null.`');
  var padding = widgetSetting.padding,
      level = widgetSetting.level,
      componentWidth = widgetSetting.componentWidth,
      product = widgetSetting.product;
  var Component = module ? _modules["default"][module] : null;
  var hasVisibleModule = Boolean(Component);
  return /*#__PURE__*/_react["default"].createElement(_radium.StyleRoot, {
    className: styles.root,
    style: level === 1 ? {
      display: 'flex',
      flexWrap: 'wrap',
      flexShrink: 0,
      alignItems: 'flex-start',
      minWidth: "".concat(componentWidth, "px")
    } : {
      display: level % 2 ? 'flex' : 'block',
      flex: "1 1 ".concat(componentWidth, "px")
    }
  }, Component ? /*#__PURE__*/_react["default"].createElement("div", {
    id: "wrapper-".concat(id),
    className: styles.wrapper
  }, /*#__PURE__*/_react["default"].createElement("style", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: "\n                  #wrapper-".concat(id, " {\n                    padding: ").concat(hasVisibleModule ? padding / 2 : 0, "px;\n                  }\n                ")
    }
  }), /*#__PURE__*/_react["default"].createElement(_GodsEye.GodsEyeProvider, {
    module: module,
    moduleId: id,
    moduleIndex: flattenedWidgets === null || flattenedWidgets === void 0 ? void 0 : flattenedWidgets.findIndex(function (widget) {
      return widget.id === id;
    }),
    customTracking: restProps === null || restProps === void 0 ? void 0 : restProps.customTracking
  }, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, restProps, {
    id: id,
    product: product,
    module: module,
    globalCarousel: globalCarousel
  })))) : widgets === null || widgets === void 0 ? void 0 : widgets.map(function (_ref, index) {
    var widgetId = _ref.id,
        data = (0, _objectWithoutProperties2["default"])(_ref, ["id"]);
    return /*#__PURE__*/_react["default"].createElement(Widget, (0, _extends2["default"])({}, data, {
      hiddenModules: hiddenModules,
      flattenedWidgets: flattenedWidgets,
      globalCarousel: globalCarousel,
      key: widgetId || "".concat(level, "-").concat(index),
      id: widgetId,
      widgetSetting: _objectSpread(_objectSpread({}, widgetSetting), {}, {
        level: level + 1
      })
    }));
  }));
};

Widget.propTypes = {
  module: _propTypes["default"].string,
  widgets: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  widgetSetting: _constants.WIDGETSETTING_TYPE.isRequired,
  hiddenModules: _propTypes["default"].arrayOf(_propTypes["default"].string)
};

var _default = (0, _radium["default"])(Widget);

exports["default"] = _default;